import type { FC } from 'react';
import { memo } from 'react';

import { NodePanelProps } from '../../types';
import PanelForm from './form';
import type { SemanticRulesExtractionNodeType } from './types';

const Panel: FC<NodePanelProps<SemanticRulesExtractionNodeType>> = ({
  id,
  formRef,
  ...props
}) => {
  return <PanelForm {...props} ref={formRef} />;
};

export default memo(Panel);
